import { styled } from '@linaria/react';
import { FileLink as BaseFileLink } from '../../pages/admin/AdminPage.styles';

export const CategoryDocumentsContainer = styled.div`
    margin-top: 20px;
`;

export const DocumentList = styled.div`
    margin-bottom: 20px;
`;

export const DocumentItem = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;

    &:last-child {
        border-bottom: none;
    }
`;

export const DeleteButton = styled.button`
    background: none;
    border: none;
    color: #dc3545;
    cursor: pointer;
    font-size: 18px;
    padding: 0 10px 0 0;
    margin-right: 10px;
    transition: color 0.2s;

    &:hover {
        color: #c82333;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

// Re-export with layout-specific flex property
export const FileLink = styled(BaseFileLink)`
    flex: 1;
`;

export const UploadSection = styled.div`
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
`;

export const HiddenFileInput = styled.input`
    display: none;
`;

export const UploadButton = styled.button`
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;

    &:hover {
        background-color: #218838;
    }

    &:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
    }
`;

export const StatusMessage = styled.div<{ type: 'success' | 'error' }>`
    margin-top: 10px;
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
    background-color: ${(props) => (props.type === 'success' ? '#d4edda' : '#f8d7da')};
    color: ${(props) => (props.type === 'success' ? '#155724' : '#721c24')};
    border: 1px solid ${(props) => (props.type === 'success' ? '#c3e6cb' : '#f5c6cb')};
`;

export const EmptyMessage = styled.p`
    color: #6c757d;
    font-style: italic;
`;

export const FileSelectionContainer = styled.div`
    margin-top: 10px;
`;

export const ConfirmUploadButton = styled.button`
    margin-left: 10px;
    padding: 5px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }

    &:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
    }
`;
